import { Button } from "@/components/Button";
import Modal from "@/components/Modal/Modal";
import { usePostDeletePolicy } from "@/requests/hooks/comply";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { tv } from "tailwind-variants";

interface IProps {
  isOpen: boolean;
  closeModal: () => void;
  id?: string;
  successRedirect: () => void;
}

const styles = tv({
  slots: {
    base: "flex flex-col items-center justify-center gap-10 text-center",
    ctaWrapper: "flex flex-row justify-center",
  },
});

const DeletePolicyModal = ({
  isOpen,
  closeModal,
  id,
  successRedirect,
}: IProps) => {
  const { t } = useTranslation();
  const { base, ctaWrapper } = styles();
  const queryClient = useQueryClient();
  const {
    mutate: deletePolicy,
    isPending: isDeletePolicyPending,
    isSuccess: isDeletePolicySuccess,
  } = usePostDeletePolicy();

  useEffect(() => {
    if (!isDeletePolicySuccess) return;

    toast.success(t("comply.policies.delete.success"));
    queryClient.removeQueries({ queryKey: ["comply", "list-policies"] });
    successRedirect();
  }, [isDeletePolicySuccess]);

  const handleDeletePolicy = () => {
    deletePolicy(parseInt(id!));
  };

  const renderContent = () => <div>{t("comply.policies.delete.confirm")}</div>;

  const renderCta = () => (
    <div className={ctaWrapper()}>
      <Button
        as="button"
        variant="primary"
        onClick={handleDeletePolicy}
        loading={isDeletePolicyPending}>
        {t("comply.policies.delete.submit")}
      </Button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} toggleIsOpen={closeModal} width="md">
      <div className={base()}>
        {renderContent()}
        {renderCta()}
      </div>
    </Modal>
  );
};

export default DeletePolicyModal;
